import * as Yup from 'yup';

export type ActivitySaleGuestDetailType = {
  isSelected?: boolean;
  activityId: string;
  activityName: string;
  date: Date;
  price: number;
  qty: number;
  totalPrice: number;
  description: string;
  id: string;
  type: string;
};

export type ActivitySaleGuestType = {
  isSelected?: boolean;
  guestId: string;
  guestName: string;
  preferences: any[];
  id: string;
  activitySaleGuestDetails: ActivitySaleGuestDetailType[];
};

export type ActivitySaleAddOnsType = {
  isSelected?: boolean;
  guestId: string;
  description: string;
  price: number;
  id: string;
};

export type ActivitySaleType = {
  id: string;
  isGroupedPrice: boolean;
  activitySaleGuests: ActivitySaleGuestType[];
  activitySaleAddOns: ActivitySaleAddOnsType[];
};

export type ActivityRescheduleFormType = {
  activitySales: ActivitySaleType[];
  transactionAt: Date | null;
  invoiceNumber?: string;
  customer?: string;
  total: number;
};

export const ActivityRescheduleSchema = Yup.object()
  .shape({
    transactionAt: Yup.date().nullable().required(),
    invoiceNumber: Yup.string().strip(true),
    customer: Yup.string().strip(true),
    activitySales: Yup.array()
      .of(
        Yup.object({
          id: Yup.string().required(),
          isGroupedPrice: Yup.boolean(),
          activitySaleGuests: Yup.array()
            .of(
              Yup.object({
                guestId: Yup.string().required(),
                id: Yup.string().required(),
                activitySaleGuestDetails: Yup.array()
                  .of(
                    Yup.object({
                      activityId: Yup.string().nullable().required(),
                      date: Yup.date().nullable().required(),
                      price: Yup.number()
                        .transform((value) =>
                          isNaN(value) ? undefined : value,
                        )
                        .min(0)
                        .required(),
                      description: Yup.string().nullable(),
                      id: Yup.string().required(),
                    }),
                  )
                  .required(),
              }),
            )
            .required(),
          activitySaleAddOns: Yup.array()
            .of(
              Yup.object({
                guestId: Yup.string().nullable().required(),
                id: Yup.string().required(),
                description: Yup.string().nullable(),
                price: Yup.number()
                  .transform((value) => (isNaN(value) ? undefined : value))
                  .min(0)
                  .required(),
              }),
            )
            .required(),
        }).required(),
      )
      .required(),
  })
  .required();
